import http from "@/settings/apiSettings"

class DocumenteTipuriDataService {
    getAll(): Promise<any> {
        return http.clientDocumenteOdata.get('DOC_Tipuri')
    }

    getByKey(key) {
        return http.clientDocumenteOdata.get(`DOC_Tipuri(${key})`)
    }
}

export default new DocumenteTipuriDataService()